// extracted by mini-css-extract-plugin
export default {"content":"SearchWrapper_content__1WvWK","fab":"SearchWrapper_fab__7crvK"};